import { type DayTimeRange, RotationType } from '../../common/types';

export const MONDAY = 2;

export const INITIAL_CUSTOM_RESTRICTIONS: DayTimeRange[] = [
	{
		startDay: MONDAY,
		startHour: 8,
		startMinute: 0,
		endDay: MONDAY,
		endHour: 17,
		endMinute: 0,
	},
];

export const DEFAULT_SHIFT_PERIOD = '1';

export const VALID_SHIFT_RANGE = {
	[RotationType.HOURLY]: { max: 720, min: 1 },
	[RotationType.DAILY]: { max: 365, min: 1 },
	[RotationType.WEEKLY]: { max: 52, min: 1 },
} as Record<RotationType, { max: number; min: number }>;
